export const StripeTestPublicKey = 'pk_test_Bqc72sP4MoYWRmMv4voE1kO3';
